import * as Logger from '../libs/wa-logger'
import * as Guards from "../libs/guards"
import * as OnBigSmall from '../components/on-screen-big-small'

export function initialize(selector: string) {
	const columns = (document.querySelectorAll(selector) as unknown) as HTMLDivElement[]
	let currentHeight
	let tallestcolumn = 0
	let isBig = false

	const setColumns = function setColumns(pcolumns: HTMLDivElement[]) {
		pcolumns.forEach((el, ix) => { // eslint-diable no-unused-vars
			const element = Guards.isHTMLDiv(el)
			currentHeight = Math.max(element.scrollHeight, element.clientHeight)
			Logger.log([`colequal currentHeight `, currentHeight])
			if (currentHeight > tallestcolumn) {
				tallestcolumn = currentHeight
			}
		});
		columns.forEach((el: HTMLDivElement, ix) => {
			// $(el).height(tallestcolumn)
			el.style.height = `${tallestcolumn}px`
		})
	};

	const resetColumns = function resetColumns(pcolumns: HTMLDivElement[]) {
		pcolumns.forEach((el: HTMLDivElement) => {
			el.style.height = ''
		});
	};

	const onGoingLarge = () => {
		Logger.log('equalHeight::GOING MEDIUM screen entered');
		if (!isBig) {
			setColumns(columns)
			isBig = true;
		}
	};

	const onGoingSmall = () => {
		Logger.log('equalHeight::GOING SMALL screen entered');
		if (isBig) {
			resetColumns(columns)
			isBig = false;
		}
	};

	// OnBigSmall.register(onGoingLarge, onGoingSmall);
}
